module.exports = __webpack_public_path__ + "static/img/wall-8m-x-4m_256.b388fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-8m-x-4m_256.png
// module id = we96
// module chunks = 0